import { node, element, string } from "prop-types";
import HeaderTitle from "../HeaderTitle";

const Header = ({ header, add, className }) => (
  <div className={`tw-flex tw-items-center ${className}`}>
    <HeaderTitle>{header}</HeaderTitle>
    {add}
  </div>
);

export default Header;

Header.propTypes = {
  header: node,
  add: element,
  className: string,
};

Header.defaultProps = {
  header: "",
  add: null,
  className: "",
};
